import { render, staticRenderFns } from "./CdlSaude.vue?vue&type=template&id=d8a2c844&scoped=true&"
import script from "./CdlSaude.vue?vue&type=script&lang=js&"
export * from "./CdlSaude.vue?vue&type=script&lang=js&"
import style0 from "./CdlSaude.vue?vue&type=style&index=0&id=d8a2c844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a2c844",
  null
  
)

export default component.exports